import React, { useEffect, useState } from 'react';
import ModalFullScreen from '../../ModalFullScreen/ModalFullScreen';
import { Dispatch } from '../../../store/store';
import { connect } from 'react-redux';
import InteractiveButton from '../../InteractiveButton/InteractiveButton';
import { IRecipe } from '../../../types/recipes-types';
import SpinnerLoader from '../../SpinnerLoader/SpinnerLoader';
import InputControl from '../../InputControl/InputControl';
import CycleSettings from '../../../enums/cycle-setting.enum';

type Props = {
  onSelect: (id: string) => any;
};
type DispatchProps = ReturnType<typeof mapDispatch>;
type ComponentProps = DispatchProps & Props;

const filterRecipes = (recipes: IRecipe[], search?: string): IRecipe[] => {
  if (!search) {
    return recipes;
  }

  return recipes.filter((rec) => rec.name.toLowerCase().includes(search.toLowerCase()));
};

export const ChooseRecipeView = ({ getRecipes, reset, onSelect }: ComponentProps) => {
  const [open, setOpen] = useState(false);
  const [recipesList, setRecipesList] = useState<IRecipe[]>([]);
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    const recipes = await getRecipes({ mode: CycleSettings.PostWeld });
    setRecipesList(recipes.filter((recipe) => recipe.mode === CycleSettings.PostWeld));
    setLoading(false);
  };

  const closeModal = ()=>{
    setOpen(false)
  }

  const onSelectHandler = (id: string)=>{
    onSelect(id)
    closeModal()
  }

  const updateSearchText = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setSearchQuery(value);
  };

  useEffect(() => {
    if (open) {
      fetchData();
      return () => {
        reset();
      };
    }
  }, [open]);

  return (
    <>
      <InteractiveButton onClick={() => setOpen(true)}>Choose Recipe</InteractiveButton>
      <ModalFullScreen
        isVisible={open}
        modalTitle="Choose Recipe"
        onClose={() => setOpen(false)}
        className="sm:max-h-fit sm:max-w-100 sm:rounded-lg lg:max-w-142.5 lg:px-17.5 lg:py-15"
      >
        {loading ? (
          <div className="flex h-75 w-full items-center justify-center">
            <SpinnerLoader />
          </div>
        ) : (
          <div className="flex h-full flex-col">
            <InputControl
              type="text"
              name="email"
              placeholder="Enter recipe name"
              value={searchQuery || ''}
              onChange={updateSearchText}
              autoComplete="off"
            />
            <div className="c-cycle-search-screen__wrapper-list flex-auto overflow-y-auto">
              {!!recipesList.length && (
                <ul className="c-cycle-search-screen__list flex flex-auto flex-col gap-y-2 overflow-y-auto overflow-x-hidden">
                  {filterRecipes(recipesList, searchQuery).map((recipe) => (
                    <li key={recipe.id} className="grid w-full grid-cols-[1fr,auto] items-center gap-x-2">
                      <span className="truncate text-left">{recipe.name}</span>
                      <InteractiveButton text={'Select'} onClick={() => onSelectHandler(recipe.id)} className="w-31" />
                    </li>
                  ))}
                </ul>
              )}
              {!filterRecipes(recipesList, searchQuery).length && searchQuery && (
                <div className="flex flex-auto items-center justify-center">
                  <span>No recipes found</span>
                </div>
              )}
            </div>
          </div>
        )}
      </ModalFullScreen>
    </>
  );
};
const mapDispatch = (dispatch: Dispatch) => ({
  getRecipes: dispatch.recipes.getRecipes,
  reset: dispatch.recipes.resetState,
});

export const ChooseRecipe = connect<null, DispatchProps, Props>(null, mapDispatch)(ChooseRecipeView);
